import PriceBlock from './PriceBlock';

export default PriceBlock;
